import { createFileRoute } from '@tanstack/react-router'
import { useTabNavStore } from '@/store/tab-nav-store'
import { Layout } from '@/components/custom/layout'
import OrganizationDetailPage from '@/components/organization-detail-route/organization-detail-page'
import { useLocation } from '@tanstack/react-router'
import { getOrganizationDetail } from '@/api/settings'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import QUERY_KEY from '@/constants/use-query-key.js'
export const Route = createFileRoute(
  '/_auth/settings/organizations/$organizationId',
)({
  beforeLoad: ({ location, params }) => {
    const pathname = location.pathname
    const tabs = useTabNavStore.getState().tabs
    if (tabs.some((tab) => tab.pathname === pathname)) return

    const { organizeId } = params
    useTabNavStore.getState().addTab(pathname, `Tổ chức ${organizeId}`)
  },
  component: OrganizeWrapper,
})

function OrganizeWrapper() {
  const pathname = useLocation().pathname
  const { organizeId } = Route.useParams()
  const [refreshTime, setRefreshTime] = useState(new Date().getTime())

  const { data: organization } = useQuery({
    queryKey: [QUERY_KEY.GET_DETAIL_ORGANIZATION, { organizeId, refreshTime }],
    queryFn: async () => {
      const resp = await getOrganizationDetail({ id: organizeId })
      return resp.data
    },
    enabled: Boolean(organizeId),
  })

  return (
    <Layout.Body>
      <OrganizationDetailPage
        pathname={pathname}
        organization={organization}
        setRefreshTime={setRefreshTime}
      />
    </Layout.Body>
  )
}
